export enum AuthRoutes {
    Login = 'login',
    Logout = 'logout'
}
